// extracted by mini-css-extract-plugin
export default {"main":"all_main__SmdgZ","status":"all_status__8rxn7","info":"all_info__0WGms","infoContainer":"all_infoContainer__atliK","docs":"all_docs__szbaN"};